import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';
import { AttendeeSortDirection } from '@/types/all-attendees.types';

type SortPayload = {
  sort: string;
  sortDirection: AttendeeSortDirection;
};

export const setAllAttendeesSort = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<SortPayload>((state, action) => {
    state.allAttendees.sort = action.payload.sort;
    state.allAttendees.sortDirection = action.payload.sortDirection;
    state.allAttendees.page = 1;
  });
